import createPersistedState from 'vuex-persistedstate'

const plugins = [
  createPersistedState({
    paths: ['auth']
  })
]

const devPlugins = [...plugins]

export default process.env.NODE_ENV !== 'production'
  ? plugins
  : devPlugins
